import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Col, Input, Row, Table } from "reactstrap";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import NotFound from "../Common/NotFound";

const LookupSponsor = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [sponsorList, setSponsorList] = useState([]);
  const [searchMember, setSearchMember] = useState(null)
  const timerRef = useRef(null);

  useEffect(() => {
    if (email) {
      getSponsorList();
    } else {
      setSponsorList([]);
      setSearchMember(null);
    }
  }, [email]);

  const getSponsorList = () => {
    setLoading(true);
    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      let url = api.lookup_sponsor;
      if (email) {
        url = url + `?email=${email}`
      }
      fetch(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          "Accept-Language": props.lang.toLowerCase(),
          "Authorization": "Bearer " + props.auth.auth.access_token,
        }),
      })
        .then((response) => response.json())
        .then(async (responseJson) => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          if (responseJson.status === "success") {
            await setSearchMember(responseJson.data[0]);
            responseJson.data.shift();
            setSponsorList(responseJson.data);
          } else {
            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
              dispatch(logout(props.history, 'login'));
            }
            console.log("error", responseJson.message);
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    }, 1000);
  }

  return (
    <>
      <div className='pb-5 wallet'>
        <Row className="mx-0 px-0 mt-3 mt-md-0">
          <Col lg={12} md={12} sm={12} xs={12} className="px-0">
            <div className="whiteContainer px-md-4 py-md-4 p-2">
              <div className="infoContainer">
                <div className="px-md-3 py-md-3 px-2 py-4">
                  <Row className="my-4 px-0 mx-0">
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <span className="infoTitle">{translate(props.lang, "Personal Information")}</span>
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Member Email")}
                        boxValue={searchMember && searchMember.email ? searchMember.email : '-'}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Name")}
                        boxValue={searchMember ? searchMember.full_name ? searchMember.full_name : searchMember.nick_name : '-'}
                        loading={loading}
                      />
                    </Col>

                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Self Deposit")}
                        boxValue={searchMember && searchMember.self_deposit ? Number(searchMember.self_deposit).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Personal Sales")}
                        boxValue={searchMember && searchMember.personal_sales ? Number(searchMember.personal_sales).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Group Sales")}
                        boxValue={searchMember && searchMember.group_sales ? Number(searchMember.group_sales).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Direct Downline")}
                        boxValue={searchMember && searchMember.direct_downline ? Number(searchMember.direct_downline).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Total Downline")}
                        boxValue={searchMember && searchMember.total_downline ? Number(searchMember.total_downline).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Active Downline")}
                        boxValue={searchMember && searchMember.active_downline ? Number(searchMember.active_downline).toLocaleString('en-US') : 0}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Auto Rank")}
                        boxValue={searchMember && searchMember.auto_rank_name ? searchMember.auto_rank_name : '-'}
                        loading={loading}
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                      <InfoBox
                        boxLabel={translate(props.lang, "Manual Rank")}
                        boxValue={searchMember && searchMember.manual_rank_name ? searchMember.manual_rank_name : '-'}
                        loading={loading}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="tableContainer">
                <Row className="align-items-center mt-4">
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="groupLabel-input">
                      <div className="input-group">
                        <Input
                          type="text"
                          placeholder={translate(props.lang, "Enter Member Email")}
                          className="form-control input-transparent py-1 px-3"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Table responsive className="w-100 mt-3 table-list text-center position-relative">
                  <thead>
                    <tr>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Member Email")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Self Deposit")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Personal Sales")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Group Sales")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Direct Downline")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Total Downline")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Active Downline")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Auto Rank")}</th>
                      <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Manual Rank")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={10}>
                          <LoadingV3 theme='light' />
                        </td>
                      </tr>
                    ) : (
                      sponsorList.length > 0 ? (
                        sponsorList.map((item, i) => (
                          <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                            <td className={`font-weight-500 font-16 text-center`}>{item.email}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.full_name ? item.full_name : item.nick_name}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{Number(item.self_deposit).toLocaleString('en-US')}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{Number(item.personal_sales).toLocaleString('en-US')}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{Number(item.group_sales).toLocaleString('en-US')}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.direct_downline ? Number(item.direct_downline).toLocaleString('en-US') : 0}</td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.total_downline ? Number(item.total_downline).toLocaleString('en-US') : 0} </td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.active_downline ? Number(item.active_downline).toLocaleString('en-US') : 0} </td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.auto_rank_name ? item.auto_rank_name : '-'} </td>
                            <td className={`font-weight-500 font-16 text-center`}>{item.manual_rank_name ? item.manual_rank_name : '-'} </td>
                          </tr>
                        ))
                      ) : (
                        <tr role="row" className={`even`}>
                          <td colSpan={10}>
                            <NotFound />
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  const { auth, i18n } = state;
  return {
    lang: i18n.lang,
    auth: auth,
  }
}

export default connect(mapStateToProps)(LookupSponsor);